import React from 'react';

const Chatroom = () => {
  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      <h1>Chatroom</h1>
    </div>
  );
};

export default Chatroom;
